// https://usehooks-ts.com/react-hook/use-isomorphic-layout-effect
import React from 'react';

import { isClient } from 'helpers/BrowserHelpers';

const useIsomorphicLayoutEffect = isClient() ? React.useLayoutEffect : React.useEffect;

export default useIsomorphicLayoutEffect;
